
"use strict";
angular.module("contractChannelServiceModule", [
    "addContractChannelModule",//添加签约渠道
]).
factory("contractChannelService", ["$modal", "$q", function($modal, $q) {
    return {

        /**
         * [pgcUserDetails description] 添加签约渠道
         * @param {[string]} [content] [description] 内容
         */
        addContractChannel: function(type,item) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/settings/contractChannel/service/addContractChannel/addContractChannel_tpl.html",
                windowClass: 'addContractChannel',
                backdrop: false,
                controller: "addContractChannelCtrl",
                resolve: {
                    type:function(){
                    	return type;
                    },
                    item:function(){
                    	return item;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },
    };
}]);